import React from 'react';
import { isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { FIELD_LENGTH, InputText, StringUtilService, ValidationService } from '@sm360/widget-commons-forms';

class InputZipCode extends React.Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.validInput = this.validInput.bind(this);
    }

    maskValue(value) {
        const trimValue = StringUtilService.removeSpaces(value);
        const zipCodeFirstPart = trimValue.substring(0, 3).toUpperCase();
        const zipCodeLastPart = trimValue.substring(3, 6).toUpperCase();
        const zipCode = `${zipCodeFirstPart} ${zipCodeLastPart}`;

        return trimValue.length > 3 ? zipCode : StringUtilService.removeSpaces(zipCode);
    }

    validInput(value) {
        const trimValue = StringUtilService.removeSpaces(value);
        const validation = ValidationService.validateZipCode(trimValue);

        if (this.props.isRequired) {
            return validation && ValidationService.validateIsNotEmpty(trimValue);
        }

        return isEmpty(value) || validation;
    }

    handleInputChange(value) {
        const maskValue = this.maskValue(value);

        this.props.valueChange({
            value: maskValue,
            validation: this.validInput(maskValue),
        });
    }

    render() {
        return (
            <InputText
                type="text"
                name="postalCode"
                classNames={this.props.classNames}
                value={this.maskValue(this.props.value)}
                label={LocaleService.t('LOGIN.PROFILE.POSTAL_CODE')}
                isRequired={this.props.isRequired}
                isValid={this.props.isValid}
                valueChange={this.handleInputChange}
                maxLength={FIELD_LENGTH.POSTAL_CODE_MAX}
            />
        );
    }
}

InputZipCode.propTypes = {
    value: React.PropTypes.string.isRequired,
    isValid: React.PropTypes.bool.isRequired,
    classNames: React.PropTypes.arrayOf(React.PropTypes.string),
    isRequired: React.PropTypes.bool,
    valueChange: React.PropTypes.func.isRequired,
};

InputZipCode.displayName = 'InputZipCode';

export default InputZipCode;



// WEBPACK FOOTER //
// ./src/components/Inputs/InputZipCode/InputZipCode.jsx